import { modelOptions, post, prop, PropType } from "@typegoose/typegoose";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";

const SCHEMA_KEY = "LoggerPayload" as const;

/** Raw network payload sent to or received from a device. */
@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<LoggerPayload>>(...addSchemaKeyHook(SCHEMA_KEY))
export class LoggerPayload extends SchemaBase<LoggerPayload> {
    static readonly schemaKey = SCHEMA_KEY;
    readonly schemaKey = SCHEMA_KEY;

    @prop({ type: () => Number, required: true }, PropType.ARRAY)
    public bytes!: number[];

    @prop({ type: () => Number, required: true })
    public fPort!: number;

    /** Idempotency token echoed back by the device to acknowledge receipt. */
    @prop({ type: () => Number, required: false })
    public idemp?: number;

    static getters = {} as const satisfies Record<string, (self: LoggerPayload) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    constructor(properties?: SchemaConstructorArgs<LoggerPayload>) {
        super(properties);
        Object.assign(this, properties);
    }
}
